module.exports = "<ui-view></ui-view>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/management/management.component.html
// module id = ../../../../../src/app/components/management/management.component.html
// module chunks = main